<template>
<div>
  <transparentheaders class="white" ref="brother"></transparentheaders>
  <div class="background">
    <div class="container">
      <div class="judge">
        <router-link :to="{path:'/mycenter',query:{roleId:userid}}">
          <el-page-header>
          </el-page-header>
        </router-link>
        <div class="content">
          <div style="height: 500px;">
            <el-steps direction="vertical" :active="active" finish-status="success" align-center>
              <el-step title="步骤1" description="填写信息"></el-step>
              <el-step title="步骤2" description="上传照片"></el-step>
              <el-step title="步骤3" description="完成"></el-step>
            </el-steps>
          </div>
          <ul v-if="active == 0" class="nameverify">
            <li class="nameitem">
              <el-input placeholder="请输入真实姓名" v-model="realname">
                <i slot="prefix"><img class="ico" src="../assets/images/name_ico.png" /></i>
              </el-input>
            </li>

            <li class="nameitem">
              <el-input placeholder="请选择身份证号" v-model="idcard" @input="validateIdNumber">
                <i slot="prefix"><img class="ico" src="../assets/images/id_ico.png" /></i>
              </el-input>
            </li>

            <li class="nameitem">
              <el-select v-model="sex" placeholder="请选择">
                <i slot="prefix"><img class="ico" src="../assets/images/sex_ico.png" /></i>
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </li>
            <li class="nameitem">
              <el-button @click="messagechange()">下一步</el-button>
            </li>

          </ul>

          <ul v-if="active == 1" class="cardverify">
            <li class="cardphoto">
              <el-upload class="upload-demo" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" accept=".tiff,.jfif,.bmp,.gif,.svg,.png,.jpeg,.svgz,.jpg,.webp,.ico,.xbm,.dib,.pjp,.apng,.tif,.pjpeg,.avif" :auto-upload="true" :on-success="updatepicture1"><img class="idpicture" :src="imageUrl1? imageUrl1 : baseImg1" alt="">
              </el-upload>

            </li>
            <li class="cardphoto">
              <el-upload class="upload-demo" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" accept=".tiff,.jfif,.bmp,.gif,.svg,.png,.jpeg,.svgz,.jpg,.webp,.ico,.xbm,.dib,.pjp,.apng,.tif,.pjpeg,.avif" :on-success="updatepicture2"><img class="idpicture" :src="imageUrl2? imageUrl2 : baseImg2"></el-upload>
            </li>

            <li class="cardphoto">
              <el-upload class="upload-demo" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" accept=".tiff,.jfif,.bmp,.gif,.svg,.png,.jpeg,.svgz,.jpg,.webp,.ico,.xbm,.dib,.pjp,.apng,.tif,.pjpeg,.avif" :on-success="updatepicture3"><img class="idpicture" :src="imageUrl3? imageUrl3 : baseImg3"></el-upload>
            </li>
            <el-button type="primary" @click="previous()">上一步</el-button>
            <el-button type="primary" @click="submitverify()">实名认证提交</el-button>
          </ul>
          <ul v-if="active == 2">
            <el-result icon="success" title="提示" subTitle="提交成功，等待后台审核">
              <template slot="extra">
                <router-link :to="{path:'/mycenter',query:{roleId:userid}}">
                  <el-button type="primary" size="medium">返回</el-button>

                </router-link>
                <el-button type="primary" @click="previous()">上一步</el-button>
              </template></el-result>
          </ul>

        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
import transparentheaders from "../components/transparentheaders.vue";
import {
  realVerify,
  queryById
} from "../api/api"
export default {
  data() {
    return {
      options: [{
        value: '选项1',
        label: '男'
      }, {
        value: '选项2',
        label: '女'
      }],
      // 上传的图片
      imageUrl1: '',
      imageUrl2: '',
      imageUrl3: '',
      // 默认的图片
      baseImg1: require('../assets/images/id_card_1.png'),
      baseImg2: require('../assets/images/id_card_2.png'),
      baseImg3: require('../assets/images/id_card_3.png'),
      sex: "",
      sexid: "",
      realname: "",
      idcard: "",
      msg: "", //弹出的消息
      dialogImageUrl: '',
      active: 0,
      pic1: "",
      pic2: "",
      pic3: "",

      userid: ""
    }
  },
  components: {
    transparentheaders
  },
  mounted() {

    queryById({
      id: this.userid
    }).then(res => {
      if (res.data.code == 200) {
        this.realname = res.data.result.name;
        this.idcard = res.data.result.personCode;
        if(res.data.result.sex) this.sex = '女'
        else this.sex = '男'
        if (res.data.result.pic1){
           this.pic1 = res.data.result.pic1
           this.imageUrl1 = imgUrl + res.data.result.pic1;
        }
        if (res.data.result.pic2) {
             this.pic2 = res.data.result.pic2
          this.imageUrl2 = imgUrl + res.data.result.pic2;
        }
          
        if (res.data.result.pic3) {
           this.pic3 = res.data.result.pic3
           this.imageUrl3 = imgUrl + res.data.result.pic3;
        }
         
      }
    });
  },

  created() {
    this.sex = this.options[0].value;
    this.userid = JSON.parse(
      sessionStorage.getItem("userinfo_Data")
    ).id
  },
  methods: {
    validateIdNumber() {
      this.idcard = this.idcard.replace(/[\u4E00-\u9FA5]/g, '').substring(0, 18);
    },
    messagechange() {
      var regName = /^[\u4e00-\u9fa5]{2,4}$/;
      // var regIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      var regIdNo = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!regIdNo.test(this.idcard)) {
        this.msg = "请填写正确的身份证号";
        this.open()
      }
      if (!regName.test(this.realname)) {
        this.msg = "请填写正确的真实姓名";
        this.open()
      }

      if (regIdNo.test(this.idcard) && regName.test(this.realname)) {
        this.next();
      }
    },
    open() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {
        // if (this.msg === "注册成功") {
        //   this.$router.push({
        //     path: "/"
        //   });
        // }
      });
    },
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    previous() {
      this.active--;
    },
    updatepicture1(res) {
      const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
      this.pic1 = res.message;
      this.imageUrl1 = imgUrl + res.message

    },
    updatepicture2(res) {
      const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
      this.pic2 = res.message
      this.imageUrl2 = imgUrl + res.message
    },
    updatepicture3(res) {
      const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
      this.pic3 = res.message
      this.imageUrl3 = imgUrl + res.message
    },
    submitverify() {
     
      if (!(this.imageUrl3)) {
        this.msg = "请上传手持身份证照";
        this.open()
      }
      if (!(this.imageUrl2)) {
        this.msg = "请上传身份证反面";
        this.open()
      }
      if (!(this.imageUrl1)) {
        this.msg = "请上传身份证正面";
        this.open()
      }
      if (this.imageUrl1 && this.imageUrl2 && this.imageUrl3) {
        if (this.sex === '男') {
          this.sexid = 0
        
        }
        if (this.sex === '女') {
          this.sexid = 1
        }
         console.log(this.sexid)
        var birthdate =
          this.idcard.substring(6, 10) +
          "-" +
          this.idcard.substring(10, 12) +
          "-" +
          this.idcard.substring(12, 14);
        let data = {
          birthdate: birthdate,
          id: this.userid,
          name: this.realname,
          personCode: this.idcard,
          pic1: this.pic1,
          pic2: this.pic2,
          pic3: this.pic3,
          sex: this.sexid,
        }
        realVerify(data).then(res => {
          if (res.data.code == 200) {
            this.next();
          }
        });
      }

    }
  }

}
</script>

<style lang="scss" scoped>
.background {
  padding: 20px;
  background: rgb(234, 242, 250);
  height: 100vh;
}

.white {
  background: white;
}

.judge {

  margin-top: 70px;
  padding: 20px;
  background: white;
  height: 830px;
}

.content {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 120px 80px;
}

.ico {

  width: 20px;
  height: 20px;
}

.idpicture {
  margin-top: -20px;
  width: 300px;
  height: 200px;
  margin-bottom: 25px;
}

>>>.el-input__inner {
  background-color: #f2f9ff;
  border: none;
  border-radius: 10px;
}

>>>.el-input--prefix .el-input__inner {
  padding-left: 35px;
}

.ico {
  margin-top: 9px;
  margin-left: 3px
}

.el-button {

  background-color: rgb(10, 108, 255);
  border-radius: 20px;
  color: rgb(255, 255, 255);
  width: 125px;

}

ul {
  text-align: center;

}

.nameitem {
  margin-top: 28px;
}

.nameverify {
  margin-top: 50px;
  margin-left: -180px;
}

.cardverify {
  margin-left: -180px;
  margin-top: -80px;
}

>>>.el-upload-list__item {
  display: none;
}

>>>.el-upload-list__item-name {
  transition: none !important;
  display: none;
}

>>>.el-upload-list__item .el-icon-upload-success {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/nameverify.vue